import styles from './InputSelect.module.scss'

interface ISelect {
  value?: string;
  onChange?: (value: string) => void;
  options?: Array<{
    value: string;
    label: string;
  }>;
  placeholder?: string;
  disabled?: boolean;
}

const InputSelect: React.FC<ISelect> = ({
  value,
  onChange,
  options = [
    { value: 'low', label: 'LOW' },
    { value: 'medium', label: 'MEDIUM' }, 
    { value: 'high', label: 'HIGH' },
    { value: 'null', label: 'NULL' }
  ],
  placeholder = 'Select',
  disabled = false
}) => {
  return (
    <select 
      className={styles.input}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      disabled={disabled}
    >
      <option value="" disabled hidden>{placeholder}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

export default InputSelect;